import React, { useState } from 'react';

import 'react-date-range/dist/styles.css'; // fichier de style principal
import 'react-date-range/dist/theme/default.css'; // fichier de style de thème

/* -------- packages -------- */
import { DateRange } from 'react-date-range';
import fr from 'date-fns/locale/fr'; // Importez la locale française de date-fns
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from "react-i18next"
/* -------- ------- -------- */

const inputStyle = {
  height: '38px',
  padding: '0 6px',
};

const buttonStyle = {
  height: '38px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 6px',
};

const iconStyle = {
  fontSize: '1.5rem', // Ajustez la taille selon vos besoins
};

const DatePickerRange = ({ column, setColumnFilter, min, max }) => {
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDateSelect = (ranges) => {
    setDateRange([ranges.selection]);
  };

  const clearDates = () => {
    setDateRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
    ]);
    setColumnFilter(column.id, undefined);
  };

  const applyDates = () => {
    const startDate = dateRange[0].startDate;
    const endDate = dateRange[0].endDate;
    setColumnFilter(column.id, { start: startDate, end: endDate });
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="input-group">
        <input
          type="text"
          value={dateRange[0].startDate ? `${dateRange[0].startDate.toLocaleDateString()} - ${dateRange[0].endDate.toLocaleDateString()}` : t('noPeriod')}
          className="form-control"
          onClick={() => setIsModalOpen(true)}
          readOnly
          style={inputStyle}
        />
        <button className="btn btn-outline-secondary" type="button" onClick={() => setIsModalOpen(true)} style={buttonStyle}>
          <i className="mdi mdi-calendar" style={iconStyle}></i>
        </button>
      </div>
      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} centered>
        <ModalHeader toggle={() => setIsModalOpen(false)}>{t('selectPeriod')}</ModalHeader>
        <ModalBody className="d-flex justify-content-center">
          <DateRange
            locale={fr}
            onChange={handleDateSelect}
            editableDateInputs={true}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            months={1}
            direction="horizontal"
            className="calendarElement"
            minDate={min}
            maxDate={max}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={clearDates}>
            {t('clear')}
          </Button>
          <Button color="primary" onClick={applyDates}>
            {t('validate')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DatePickerRange;
